import classes from './CargoForm.module.sass'
import { format } from 'date-fns'
import { Input } from '../../../common/components/input/Input'
import { Textarea } from '../../../common/components/textarea/Textarea'
import { Button } from '../../../common/components/button/Button'
import { Regularity } from '../../../common/components/regularity/Regularity'
import { FormStage } from '../../../common/types/enums'
import { useCargoForm } from './hooks/useCargoForm'
import { FileUpload } from '../../../common/components/fileUpload/FileUpload'
import { PointForm } from '../../../common/components/form/pointForm/PointForm'
import { Toggle } from '../../../common/components/toggle/Toggle'
import { GMapForRoute } from '../../../common/components/maps/gMapForRoute/GMapForRoute'
import { Helmet } from 'react-helmet-async'
import { CargoSelector } from '../../../common/components/cargoSelector/CargoSelector'
import TransportTypeSelector from '../../../common/components/transportTypeSelector/TransportTypeSelector'

export const CargoForm = () => {
  const {
    inputHandler,
    data,
    setData,
    getValidationResult,
    disabled,
    setDirty,
    formStage,
    setFormStage,
    disabled1,
    disabled2,
    formAction,
    files,
    setFiles,
    pairs,
    setPairs,
    addresses,
    setAddresses,
    isRoute,
    edit,
    editPointsData,
    toggleIntercity,
    setCargoTypeValid,
    setTransportTypeValid,
    toggleStartImportant,
    toggleEndImportant,
  } = useCargoForm()

  return (
    <div className={classes.Container} onClick={(e) => e.stopPropagation()}>
      <Helmet>
        <title>{`logid - форма добавления груза`}</title>
        <meta
          name="description"
          content={`Добавить груз с указанием города, адреса, нескольких точек разгрузки`}
        />
      </Helmet>
      <div className={classes.Title}>{edit ? 'Редактирование груза' : 'Новый груз'}</div>
      {formStage === FormStage.ONE && (
        <div className={classes.StageContainer}>
          <CargoSelector
            setTopData={setData}
            setCargoTypeValid={setCargoTypeValid}
            topData={data}
          />
          <TransportTypeSelector
            setTopData={setData}
            setTransportTypeValid={setTransportTypeValid}
            topData={data}
            multiple
          />
          <div className={classes.Toggles}>
            <div className={classes.ToggleContainer}>
              <Toggle id={'intercity'} onChange={toggleIntercity} checked={data.intercity} />
              <div>Междугородняя доставка</div>
            </div>
            {data.intercity && (
              <div className={classes.ToggleContainer}>
                <Toggle
                  id={'addresses'}
                  onChange={() => {
                    setAddresses((prev) => !prev)
                  }}
                  checked={addresses}
                />
                <div>Указывать точные адреса</div>
              </div>
            )}
          </div>

          <Input
            type={'text'}
            fieldName={'name'}
            value={data.name}
            placeHolder={'Название груза'}
            onChangeHandler={inputHandler}
            itemValidationResult={getValidationResult('name')}
            onBlur={setDirty}
          />

          <Textarea
            type={'textarea'}
            fieldName={'description'}
            value={data.description}
            placeHolder="Опишите груз подробно"
            rows={5}
            cols={20}
            onChangeHandler={inputHandler}
            itemValidationResult={getValidationResult('description')}
            onBlur={setDirty}
          />

          <Input
            type={'numberText'}
            fieldName={'cost'}
            value={data.cost ? data.cost : ''}
            placeHolder={'Предлагаемая стоимость'}
            onChangeHandler={inputHandler}
            itemValidationResult={getValidationResult('cost')}
            onBlur={setDirty}
          />
        </div>
      )}

      {formStage === FormStage.TWO && (
        <div className={classes.StageContainer}>
          <PointForm
            addresses={addresses}
            intercity={Boolean(data.intercity)}
            topData={data}
            setTopData={setData}
            isRoute={isRoute}
            initialData={editPointsData && editPointsData}
          />
          <div className={classes.MapContainer}>
            <GMapForRoute
              data={data}
              intercity={Boolean(data.intercity)}
              addresses={addresses}
              setData={setData}
            />
          </div>
        </div>
      )}

      {formStage === FormStage.THREE && (
        <div className={classes.StageContainer}>
          {isRoute && (
            <div className={classes.TimeContainer}>
              <div className={classes.ToggleContainer}>
                <Toggle
                  id={'start_important'}
                  onChange={toggleStartImportant}
                  checked={data.start_important}
                />
                <div>Указать время начала</div>
              </div>

              {data.start_important && (
                <>
                  <Input
                    label="Время подачи"
                    type="datetime-local"
                    fieldName="startTime"
                    onChangeHandler={inputHandler}
                    value={`${format(new Date(data.startTime), 'yyyy-MM-dd')}T${format(
                      new Date(data.startTime),
                      'HH:mm',
                    )}`}
                  />
                  <div className={classes.ToggleContainer}>
                    <Toggle
                      id={'end_time'}
                      onChange={toggleEndImportant}
                      checked={data.end_important}
                    />
                    <div>Указать время окончания</div>
                  </div>
                </>
              )}
              {data.end_important && (
                <Input
                  label="Время доставки"
                  type="datetime-local"
                  fieldName="endTime"
                  onChangeHandler={inputHandler}
                  value={`${format(new Date(data.endTime), 'yyyy-MM-dd')}T${format(
                    new Date(data.endTime),
                    'HH:mm',
                  )}`}
                />
              )}
            </div>
          )}
          {/* <Regularity /> */}

          <FileUpload
            length={3}
            min_length={1}
            extensions={['jpeg', 'png', 'jpg', 'webp']}
            files={files}
            setFiles={setFiles}
            pairs={pairs}
            setPairs={setPairs}
          />
        </div>
      )}

      <div className={classes.ButtonsContainer}>
        {formStage !== FormStage.ONE && (
          <Button
            text={'Назад'}
            onClick={() => {
              setFormStage((prev) => prev - 1)
              window.scroll(0, 0)
            }}
          />
        )}

        <Button
          text={formStage !== FormStage.THREE ? 'Продолжить' : edit ? 'Сохранить' : 'Добавить груз'}
          disabled={
            (disabled && formStage === FormStage.THREE) ||
            (disabled1 && formStage === FormStage.ONE) ||
            (disabled2 && formStage === FormStage.TWO)
          }
          onClick={() => {
            if (formStage !== FormStage.THREE) {
              setFormStage((prev) => prev + 1)
              window.scroll(0, 0)
            } else formAction()
          }}
        />
      </div>
    </div>
  )
}
